import styled from "styled-components";

interface HeaderPageProps {
  $isOpen: boolean;
}

export const HeaderPage = styled.div<HeaderPageProps>`
  position: fixed;
  top: 0;
  right: 0;
  height: 4em;
  background: var(--backgroundColorCard);
  border-bottom: 1px solid var(--border);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  padding-left: 12px;
  left: 0;
  transition: all 0.3s;
  z-index: 99;

  @media (min-width: 768px) {
    height: 4.5em;
    padding: 0 20px;
    padding-left: 20px;
  }

  @media (min-width: 992px) {
    padding-left: ${({ $isOpen }) => ($isOpen ? "17rem" : "88px")};
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (min-width: 992px) {
    justify-content: flex-end;
    width: auto;
    flex: 0 0 auto;
  }
`;

export const Link = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Helvetica Neue Medium";
  font-size: 1.4rem;
  display: none;

  @media (min-width: 992px) {
    display: block;
  }
`;

export const BoxSearch = styled.div`
  max-width: 576px;
  width: calc(100% - 529px);
  margin: 0 15px 0 0;

  @media (min-width: 992px) {
    margin: 0 3rem;
  }
`;

export const BoxLastItemsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (min-width: 768px) {
    gap: 15px;
  }
`;

export const MobileMenuButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: transparent;
  border: 1px solid var(--borderColor);
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    width: 20px;
    height: 20px;
    color: var(--textColor);
  }

  &:hover {
    background: var(--lightGray);
    border-color: var(--primarySystem100);
  }

  @media (min-width: 992px) {
    display: none;
  }
`;

export const MobileControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (min-width: 992px) {
    display: none;
  }
`;

export const DesktopControls = styled.div`
  display: none;
  align-items: center;
  gap: 8px;

  @media (min-width: 768px) {
    gap: 15px;
  }

  @media (min-width: 992px) {
    display: flex;
  }
`;

export const MobileLogoLink = styled.a`
  display: flex;
  align-items: center;
  width: 100px;
  flex-shrink: 0;

  @media (min-width: 992px) {
    display: none;
  }
`;
